export const viewTypes = {
    date: 'date',
    month: 'month',
    year: 'year'
};